// DS: CO0.1M
import React, { useContext } from 'react';
import classnames from 'classnames';
import PublishedTime from '../_partials/PublishedTime';
import WatchButton from './WatchButton';
import MoneyPromoButton from './MoneyPromoButton';
import BackButton from './BackButton';
import RootLayout from './RootLayout';
import UserInfoBlock from './UserInfoBlock';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './MobileSubmissionDetailsHeader.scss';
var MobileSubmissionDetailsHeader = function (_a) {
    var _b;
    var currentItem = _a.currentItem, isOwner = _a.isOwner, parent = _a.parent, _c = _a.isSticky, isSticky = _c === void 0 ? true : _c, isStuck = _a.isStuck;
    var publishedTime = currentItem === null || currentItem === void 0 ? void 0 : currentItem.publishedTime;
    var moneyPromo = (_b = currentItem === null || currentItem === void 0 ? void 0 : currentItem.extended) === null || _b === void 0 ? void 0 : _b.showStageMonetizationPromo;
    var author = currentItem === null || currentItem === void 0 ? void 0 : currentItem.author;
    var adsEnabled = useContext(SessionContext).adsEnabled;
    var ads_nitro = useFlag('ads_nitro');
    return (React.createElement(RootLayout, { className: classnames(s['root'], isSticky && s['sticky'], isStuck && s['stuck'], moneyPromo && s['money-promo']), prefix: (parent || (adsEnabled && ads_nitro)) && React.createElement(BackButton, null), left: React.createElement(React.Fragment, null,
            author && (React.createElement(UserInfoBlock, { user: author, publishedTime: publishedTime, moneyPromo: moneyPromo })),
            !author && publishedTime && (React.createElement(PublishedTime, { publishedTime: publishedTime, withoutText: true }))), right: React.createElement(React.Fragment, null,
            moneyPromo && !isOwner && author && (React.createElement(MoneyPromoButton, { moneyPromo: moneyPromo, user: author, relevantDeviation: currentItem })),
            !moneyPromo && !isOwner && author && React.createElement(WatchButton, { user: author })) }));
};
MobileSubmissionDetailsHeader.displayName = 'MobileSubmissionDetailsHeader';
export default MobileSubmissionDetailsHeader;
//# sourceMappingURL=MobileSubmissionDetailsHeader.js.map